import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.autoRelease.loading;
export const selectErrorMessage = (state: RootState) => state.autoRelease.error;
export const autoReleaseDataResponse = (state: RootState) =>
  state.autoRelease.autoReleaseResponse;
